import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alert-box-modal',
  templateUrl: './alert-box-modal.component.html',
  styleUrls: ['./alert-box-modal.component.scss']
})
export class AlertBoxModalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
